// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `ion-title {
  text-align: left;
}

.title1 {
  font-size: 12px;
  text-align: center;
}

.title2 {
  font-size: 30px;
  text-align: center;
  font-weight: bold;
}

.col1 {
  margin-top: 10px;
}

ion-item {
  --background: #ecf0fd;
  border-radius: 10px;
}

.btn1 {
  --background: #2C3539;
  --color: white;
  --background-hover: transparent;
  --background-focused: transparent;
}

.row3 {
  margin-top: 30px;
}

.row4 {
  margin-top: 20px;
  margin-bottom: 10px;
}`, "",{"version":3,"sources":["webpack://./src/app/verify-otp/verify-otp.page.scss","webpack://./../../Open%20Source/cashloan-mobile-app/src/app/verify-otp/verify-otp.page.scss"],"names":[],"mappings":"AAAA;EACI,gBAAA;ACCJ;;ADEA;EACI,eAAA;EACA,kBAAA;ACCJ;;ADEA;EACI,eAAA;EACA,kBAAA;EACA,iBAAA;ACCJ;;ADEA;EACI,gBAAA;ACCJ;;ADEA;EACI,qBAAA;EACA,mBAAA;ACCJ;;ADEA;EACI,qBAAA;EACA,cAAA;EACA,+BAAA;EACA,iCAAA;ACCJ;;ADEA;EACI,gBAAA;ACCJ;;ADEA;EACI,gBAAA;EACA,mBAAA;ACCJ","sourcesContent":["ion-title {\n    text-align: left;\n}\n\n.title1 {\n    font-size: 12px;\n    text-align: center;\n}\n\n.title2 {\n    font-size: 30px;\n    text-align: center;\n    font-weight: bold;\n}\n\n.col1 {\n    margin-top: 10px;\n}\n\nion-item {\n    --background: #ecf0fd;\n    border-radius: 10px;\n}\n\n.btn1 {\n    --background: #2C3539;\n    --color: white;\n    --background-hover: transparent;\n    --background-focused: transparent;\n}\n\n.row3 {\n    margin-top: 30px;\n}\n\n.row4 {\n    margin-top: 20px;\n    margin-bottom: 10px;\n}\n","ion-title {\n  text-align: left;\n}\n\n.title1 {\n  font-size: 12px;\n  text-align: center;\n}\n\n.title2 {\n  font-size: 30px;\n  text-align: center;\n  font-weight: bold;\n}\n\n.col1 {\n  margin-top: 10px;\n}\n\nion-item {\n  --background: #ecf0fd;\n  border-radius: 10px;\n}\n\n.btn1 {\n  --background: #2C3539;\n  --color: white;\n  --background-hover: transparent;\n  --background-focused: transparent;\n}\n\n.row3 {\n  margin-top: 30px;\n}\n\n.row4 {\n  margin-top: 20px;\n  margin-bottom: 10px;\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
